import { v2 as client } from '@/apis/client'
import { AxiosPromise } from 'axios'
import {
  AllCompletedWorkStatusParams,
  AllCompletedWorkStatusResponse,
  MyCompletedWorkStatusParams,
  MyCompletedWorkStatusResponse,
} from '@/types/workStatusType'

export default {
  getAllCompletedWorkStatus: (
    regionId: number,
    params: AllCompletedWorkStatusParams
  ): AxiosPromise<Array<AllCompletedWorkStatusResponse>> =>
    client.get(`/operating/regions/${regionId}/completes`, { params }),
  getMyCompletedWorkStatus: (
    userId: number,
    params: MyCompletedWorkStatusParams
  ): AxiosPromise<MyCompletedWorkStatusResponse> =>
    client.get(`/operating/users/${userId}/completes?t=${Date.now()}`, { params }),
}
